// Brand constants for The Best Bronze
export const BRAND = {
  name: "The Best Bronze",
  slogan: "Cel mai frumos bronz, fără UV.",
  phone: "0726 611 967",
  phoneHref: "tel:+40726611967",
  email: "bronzethebest1@gmail.com",
  emailHref: "mailto:bronzethebest1@gmail.com",
  address: "Bulevardul Republicii nr 1, Piatra Neamț 610005",
  instagram: "https://instagram.com/thebestbronze",
  facebook: "https://facebook.com/thebestbronze",
};

// Real client-provided artifacts. Each section uses a unique image — no repetition.
// Gallery editorial shots are AI-generated (Gemini Nano Banana) at the client's request
// and served as static assets from /generated/.
export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_best-bronze-landing/artifacts/pw1axwxp_cc6c6f17-41a2-4def-a79f-364e2b07f207.png",
  beforeAfter: "https://customer-assets.emergentagent.com/job_best-bronze-landing/artifacts/2vbggnk2_bronze.png",
  stickerGlow: "https://customer-assets.emergentagent.com/job_best-bronze-landing/artifacts/6vxye7z0_2492ac79-ca28-46b5-a74b-1dbd299c22d9.png",
  about: "https://customer-assets.emergentagent.com/job_best-bronze-landing/artifacts/zrk07dza_001bd5d6-02b4-4070-9394-89ead900c16a.png",
  products: "https://customer-assets.emergentagent.com/job_best-bronze-landing/artifacts/8c50iwjr_ChatGPT%20Image%20May%2030%2C%202026%2C%2010_47_49%20AM.png",
  // Service card hero — bikini-bej, real client photo (Bronz Organic Clasic)
  serviceBronzeIntense:
    "https://customer-assets.emergentagent.com/job_best-bronze-landing/artifacts/f5h0jjz8_7ccd75b8-0e3b-4d63-a464-bd0cd4cfde76.png",
  // Heart-shape sticker on bronze skin — used on "Bronz Organic Clasic" service card
  serviceHeartSticker:
    "https://customer-assets.emergentagent.com/job_best-bronze-landing/artifacts/s3c7jh83_bronzeeeee.png",
  // Gallery — 3 unique editorial generated images (not used anywhere else)
  galleryGlowBack: "/generated/gallery_glow_back.png",
  galleryLegsDetail: "/generated/gallery_legs_detail.png",
  galleryHandShoulder: "/generated/gallery_hand_shoulder.png",
};

export const NAV_LINKS = [
  { href: "#beneficii", label: "Beneficii" },
  { href: "#servicii", label: "Servicii" },
  { href: "#sticker-glow", label: "Sticker Glow" },
  { href: "#galerie", label: "Galerie" },
  { href: "#faq", label: "Întrebări" },
  { href: "#rezervare", label: "Rezervare" },
];
